import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { AdminTravelReimbursementGridPostParams, AdminTravelReimbursementListingModel } from 'common/models/page-models/travel-reimbursement/admin-travel-grid-model';
import { TravelReimbursementModel } from 'common/models/page-models/travel-reimbursement/travel-reimbursement-data.model';



@Injectable({
    providedIn: 'root'
})
export class AdminTravelReimbursementGridDataService extends GridDataService<AdminTravelReimbursementListingModel, TravelReimbursementModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.getTravelReimbursementAssignmentListForSuperAdmin, http, ss);
    }

    createInstance(): AdminTravelReimbursementListingModel {
        return new AdminTravelReimbursementListingModel();
    }

    override getDeleteUrl(): string {
        return '';
    }

    override getGridParams(param): GridPostParams {
        return new AdminTravelReimbursementGridPostParams();
    }

    override getDataParam(): string {
        return 'details';
    }

    // override transformDataModel(apiRes: any, param: string) {
    //     super.transformDataModel(apiRes, param);

    //     apiRes[param].forEach(element => {
    //         element['uploadDate'] =  new Date(element.travelDocUploadedDate).toLocaleDateString();
    //     });
    //     return apiRes;
    // }
}
